import { render, staticRenderFns } from "./Items.vue?vue&type=template&id=6ebe4194"
import script from "./Items.vue?vue&type=script&setup=true&lang=js"
export * from "./Items.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports